export const environment = {
  production: true,
  apiUrl: 'https://api.dev.guidl.tours',
};
